import { useQuery, type UseQueryResult } from 'react-query'

import type { TrendDetectionService } from 'features/trend-detection/service/service'
import type { IssueAgentResponse } from 'features/trend-detection/types'

export interface UseEditIssueAgentQueryParams {
  service: TrendDetectionService
  projectId: string | null
  agentId: string | null
  enabled: boolean
}

/** The edit-mode create form's issue-agent fetch — the only caller that
 * needs the staleness verdict, so the only one that asks `fetchAgent` to
 * compute it (see its doc comment). Split out of the Container so a
 * TanStack query hook doesn't live inline there. */
export function useEditIssueAgentQuery({
  service,
  projectId,
  agentId,
  enabled,
}: UseEditIssueAgentQueryParams): UseQueryResult<IssueAgentResponse> {
  return useQuery({
    queryKey: ['trend-agent', projectId, agentId],
    queryFn: async () => {
      if (!projectId || !agentId) throw new Error('missing')
      return service.fetchAgent(projectId, agentId, { checkStaleFilters: true })
    },
    enabled,
  })
}
